"use strict";

var _core = require("@emotion/core");

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AreaGraph = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var utils_2 = require("../../utils"); //import ApexCharts from 'apexcharts';


var dynamic_1 = __importDefault(require("next/dynamic"));

var ReactApexCharts = dynamic_1["default"](function () {
  return Promise.resolve().then(function () {
    return __importStar(require('react-apexcharts'));
  });
}, {
  ssr: false
});

var foundation_1 = require("../../theme/foundation");

var chartOptions = {
  chart: {
    type: 'area',
    toolbar: {
      show: false
    }
  },
  stroke: {
    curve: 'smooth'
  },
  colors: foundation_1.colors.graphColors,
  fill: {
    type: 'gradient',
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.7,
      opacityTo: 0.9,
      stops: [0, 90, 100]
    }
  },
  legend: {
    horizontalAlign: 'center',
    offsetX: 40
  },
  tooltip: {
    x: {
      format: 'dd/MM/yy HH:mm'
    }
  }
};
exports.AreaGraph = utils_2.forwardRef(function Grid(props, ref) {
  var graphRef = React.useRef();
  var chartHeight = props.chartHeight,
      series = props.series,
      xAxis = props.xAxis,
      _a = props.stacked,
      stacked = _a === void 0 ? false : _a,
      _b = props.displayLabels,
      displayLabels = _b === void 0 ? false : _b,
      _c = props.legend,
      legend = _c === void 0 ? false : _c,
      graphColors = props.graphColors,
      gradient = props.gradient;
  chartOptions.chart.height = chartHeight;
  chartOptions.chart.stacked = stacked;
  chartOptions.series = series;
  chartOptions.dataLabels = {
    enabled: displayLabels
  };
  chartOptions.xaxis = {
    categories: xAxis
  };
  chartOptions.legend.show = legend;

  if (graphColors && !!graphColors.length) {
    chartOptions.colors = graphColors;
  }

  if (!gradient) {
    chartOptions.fill.gradient = {
      shadeIntensity: 1,
      opacityFrom: 0.8,
      opacityTo: 0.8,
      stops: [100, 100, 100]
    };
  } // @ts-ignore


  return (0, _core.jsx)(ReactApexCharts, _extends({
    ref: graphRef
  }, chartOptions.chart, chartOptions, {
    options: chartOptions,
    height: chartHeight,
    series: series
  }));
});

if (utils_1.isDev) {
  exports.AreaGraph.displayName = 'AreaGraph';
}